import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { TableLink } from '@aaimplatform/ui';
import type { TableLinkComponentProps } from '@aaimplatform/ui';

/**
 * Adapts react-router's Link (which takes `to`) to TableLink's `href`
 * contract. The click stops at the link so a grid that treats a row click as
 * selection or activation does not also receive it.
 */
function RouterTableLinkAdapter({ href, className, children }: TableLinkComponentProps) {
  return (
    <Link to={href} className={className} onClick={(event) => event.stopPropagation()}>
      {children}
    </Link>
  );
}

/**
 * The kit's TableLink routed through the SPA router: a table cell that opens a
 * detail page is a real link with an href, in the secondary text color. The
 * operator tables built these cells as red <button> elements, which set plain
 * data in the CTA color and announced page navigation as a button.
 */
export function RouterTableLink({
  to,
  children,
  className,
}: {
  to: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <TableLink href={to} LinkComponent={RouterTableLinkAdapter} className={className}>
      {children}
    </TableLink>
  );
}
